module.exports = __webpack_public_path__ + "static/media/photo1@2x.db268314.jpg";